import React from "react";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@shared/ui/card";
import { BarChart } from "@shared/ui/chart";

interface ContentDistributionChartProps {
  dashboardData?: {
    faqCategoryCounts: Record<string, number>;
  };
}

export const ContentDistributionChart = ({ dashboardData }: ContentDistributionChartProps) => {
  if (!dashboardData?.faqCategoryCounts) return null;

  const categoryDistributionData = Object.entries(dashboardData.faqCategoryCounts).map(
    ([category, count]) => ({
      category,
      count
    })
  );

  return (
    <Card>
      <CardHeader>
        <CardTitle className="card-heading-text">Content Distribution by Category</CardTitle>
        <CardDescription  className="card-subheading-text">Number of FAQs per category</CardDescription>
      </CardHeader>
      <CardContent>
        <BarChart
          data={categoryDistributionData}
          index="category"
          categories={["count"]}
          colors={["#6366F1"]}
          valueFormatter={(value) => `${value} items`}
          className="h-[250px]"
        />
      </CardContent>
    </Card>
  );
};